import { NotificationsService } from './shared/notifications.service';
import { INotification } from './shared/notifications.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notifications: INotification[] = [];
  sampleNotifications: INotification[] = [];
  constructor(private service: NotificationsService) { }

  private loadData() {
    this.sampleNotifications = [
      {
        _id: '',
        name: 'Tin push ngày 31/05',
        subject: 'Sở GTVT TpHCM thông báo',
        content: `Từ 06 giờ 00 ngày 29/4/2017, các loại phương tiện được phép lưu thông 02 chiều trên đường Phan Văn Trị
        (kể cả cầu Hang Trong) đoạn từ đường Phạm Văn Đồng đến cầu Hang Trong.`,
        ts: new Date(),
        scheduledAt: new Date(+new Date() + 45 * 60 * 1000),
        status: 'draft',
        geo: {}
      }
    ];

    this.service.query().subscribe((res: any) => {
      this.notifications = res;
    });
  }

  ngOnInit() {
    this.loadData();
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/notifications.component.ts